import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, mergeProps as _mergeProps, createTextVNode as _createTextVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55bd7080"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-emerald font-weight-bold" }, "● ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-grey-lighten-1" }, "En línea", -1))
const _hoisted_3 = { class: "text-body-2 text-grey-lighten-3 lh-base" }
const _hoisted_4 = { class: "text-right text-caption mt-1 opacity-50 font-weight-light" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex mb-4 justify-start animate-fade-in"
}
const _hoisted_6 = { class: "d-flex align-center gap-2" }
const _hoisted_7 = { class: "text-body-2 text-grey-lighten-1" }
const _hoisted_8 = { class: "text-subtitle-1 font-weight-bold mb-3 d-flex align-center text-indigo-lighten-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-2 font-weight-bold mb-2 text-grey-lighten-1" }, "🚦 Estados de Dispositivos", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-emerald me-1" }, "●", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Operativo", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-amber me-1" }, "●", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Advertencia", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red me-1" }, "●", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Crítico", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-grey me-1" }, "●", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Offline", -1))
const _hoisted_18 = { class: "font-weight-bold mb-1 text-amber-lighten-2 text-caption d-flex align-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "ps-4 text-grey-lighten-1",
  style: {"font-size":"11px","line-height":"1.4"}
}, [
  /*#__PURE__*/_createElementVNode("li", null, "Consulta una IP a la vez."),
  /*#__PURE__*/_createElementVNode("li", null, "Entorno seguro de solo lectura."),
  /*#__PURE__*/_createElementVNode("li", null, "Al cerrar el chat, los datos de sesión se eliminan.")
], -1))
const _hoisted_20 = { class: "d-flex align-center pl-1" }

import { ref, watch, nextTick, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { getUserLoginToken, useChat } from '@/services/Smartlink/IA';
import { LABELS } from '@/constants/labels';

interface Message {
  rol: 'usuario' | 'asistente';
  contenido: string;
  hora: string; // <-- Corregido: Hora dinámica por mensaje
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FloatingButton',
  setup(__props) {

const store = useStore();
const { t } = useI18n();

// Estructura de ayuda optimizada para legibilidad en el template
const ayudaItems = [
  { titulo: '🌡️ Temperatura', ejemplo: '"¿Cuántos grados tiene DT659?"' },
  { titulo: '⚡ Voltaje', ejemplo: '"¿Cómo está el voltaje de 108-PRG?"' },
  { titulo: '📶 Señal / Latencia', ejemplo: '"Revisa la latencia de 102-PRG."' },
  { titulo: '🔄 Conectividad', ejemplo: '"¿Se reinició DT660 hoy?"' },
  { titulo: '📋 Estado General', ejemplo: '"Diagnóstico completo de 147-PRG."' },
];

const chatOpen = ref(false);
const menuOpen = ref(false);
const userInput = ref('');
const chatContainer = ref<any>(null); // Tipo modificado para compatibilidad Vuetify 3 

// Helper para conseguir la hora formateada actual
const getActualTime = () => {
  const now = new Date();
  return now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

const messages = ref<Message[]>([
  { rol: 'asistente', contenido: 'Bienvenido a Smartlink V2.6. ¿En qué puedo ayudarte hoy?', hora: getActualTime() }
]);

// --- ESTADOS DE AUDIO ---
const isRecording = ref(false);
const transcription = ref('');
const audioUrl = ref<string | null>(null);

let mediaRecorder: MediaRecorder | null = null;
let audioChunks: Blob[] = [];
let recognition: any = null;

const setupSpeechRecognition = () => {
  const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
  if (!SpeechRecognition) return;

  recognition = new SpeechRecognition();
  recognition.lang = 'es-ES';
  recognition.continuous = true;
  recognition.interimResults = true;

  recognition.onresult = (event: any) => {
    let interimTranscript = '';
    for (let i = event.resultIndex; i < event.results.length; ++i) {
      if (event.results[i].isFinal) {
        transcription.value += event.results[i][0].transcript + ' ';
      } else {
        interimTranscript += event.results[i][0].transcript;
      }
    }
  };
};

const startAll = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    mediaRecorder = new MediaRecorder(stream);
    audioChunks = [];
    
    mediaRecorder.ondataavailable = (e) => audioChunks.push(e.data);
    mediaRecorder.onstop = () => {
      const audioBlob = new Blob(audioChunks, { type: 'audio/webm' });
      audioUrl.value = URL.createObjectURL(audioBlob);
    };

    mediaRecorder.start();
    if (!recognition) setupSpeechRecognition();
    recognition?.start();
    isRecording.value = true;
  } catch (err) {
    console.error("Error al acceder al micrófono:", err);
  }
};

const stopAll = () => {
  mediaRecorder?.stop();
  recognition?.stop();
  isRecording.value = false;

  if (chatOpen.value) {
    setTimeout(() => {
      if (transcription.value.trim()) {
        userInput.value = transcription.value;
        handleSend();
      }
    }, 400);
  }
};

// --- LOGICA DE AUTO-SCROLL MEJORADA (Vuetify 3 native element safe) ---
watch(messages, async () => {
  await nextTick();
  if (chatContainer.value) {
    // Si chatContainer es un componente Vuetify obtenemos el HTML nativo mediante $el si aplica, o directo si es un elemento
    const targetEl = chatContainer.value.$el || chatContainer.value;
    if (targetEl && typeof targetEl.scrollTo === 'function') {
      targetEl.scrollTo({
        top: targetEl.scrollHeight,
        behavior: 'smooth'
      });
    }
  }
}, { deep: true });

watch(chatOpen, (isOpen) => {  
  if (!isOpen) {
    stopAll();
    isLoading.value = false;
  }
});

const TOKEN = ref('');
const CHAT_ID = Math.random().toString(36).substring(2, 15);
const selectedDevice = ref(null);

async function getUserToken() {
  const allData = await getUserLoginToken();
  if (allData.status === 400) {
    store.commit('showSnackBar', { type: LABELS.error, msg: t('snackbar.errorApis'), valor: true });
  }
  if (allData.status === 200) {
    TOKEN.value = allData.data.token;
  }
}

const isLoading = ref(false);
const messageLoading = ref('');
const { messagesChat, connectAndSendMessage } = useChat();
const computedMessagesIA = computed(() => messagesChat.value);

watch(computedMessagesIA, (newVal) => {
  if (newVal.length > 0) {
    const lastMessage = newVal[newVal.length - 1];
    if (lastMessage.estado === 'SUCCESS') {
      isLoading.value = false;
      messageLoading.value = '';
      messages.value.push({ 
        rol: 'asistente', 
        contenido: lastMessage.mensaje,
        hora: getActualTime()
      });
    }
    if (lastMessage.estado === 'LOADING') {
      messageLoading.value = lastMessage.mensaje;
    }
  }
}, { deep: true });

const handleSend = () => {
  if (userInput.value.trim()) {
    isLoading.value = true;
    messages.value.push({ 
      rol: 'usuario', 
      contenido: userInput.value,
      hora: getActualTime() 
    });

    connectAndSendMessage(TOKEN.value, CHAT_ID, userInput.value, selectedDevice.value || { name: 'No seleccionado', ip: 'N/A' });
    
    // Limpieza de estados post-envío
    userInput.value = ''; 
    transcription.value = ''; 
  }
};

onMounted(async () => {
  await getUserToken();
  setupSpeechRecognition();
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!chatOpen.value)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          icon: "mdi-robot-outline",
          color: "#6366f1",
          size: "large",
          elevation: "4",
          class: "chat-fab pulse-effect",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (chatOpen.value = true))
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_expand_transition, null, {
      default: _withCtx(() => [
        (chatOpen.value)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              class: "chat-window d-flex flex-column",
              theme: "dark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_toolbar, {
                  color: "#0d1117",
                  density: "comfortable",
                  class: "border-b border-grey-darken-3 px-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, {
                      "prepend-avatar": "https://cdn-icons-png.flaticon.com/512/4712/4712035.png",
                      title: "Agente Smartlink",
                      subtitle: "En línea • Inteligencia Artificial",
                      class: "pa-0"
                    }, {
                      subtitle: _withCtx(() => [
                        _hoisted_1,
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      icon: "mdi-close",
                      variant: "text",
                      density: "comfortable",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (chatOpen.value = false))
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, {
                  ref_key: "chatContainer",
                  ref: chatContainer,
                  class: "flex-grow-1 overflow-y-auto pa-4 bg-chat-modern"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (msg, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: _normalizeClass(['d-flex mb-4 animate-fade-in', msg.rol === 'usuario' ? 'justify-end' : 'justify-start'])
                      }, [
                        _createVNode(_component_v_sheet, {
                          color: msg.rol === 'usuario' ? '#312e81' : '#161b22',
                          class: _normalizeClass(['pa-3 msg-bubble border', msg.rol === 'usuario' ? 'border-indigo-darken-2' : 'border-grey-darken-3']),
                          elevation: "2"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(msg.contenido), 1),
                            _createElementVNode("div", _hoisted_4, _toDisplayString(msg.hora), 1)
                          ]),
                          _: 2
                        }, 1032, ["color", "class"])
                      ], 2))
                    }), 128)),
                    (isLoading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_v_sheet, {
                            color: "#161b22",
                            class: "pa-3 msg-bubble border border-grey-darken-3",
                            elevation: "2"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_v_progress_circular, {
                                  indeterminate: "",
                                  size: "16",
                                  width: "2",
                                  color: "indigo-lighten-2",
                                  class: "me-2"
                                }),
                                _createElementVNode("span", _hoisted_7, _toDisplayString(messageLoading.value || 'Pensando...'), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 512),
                _createVNode(_component_v_divider, { class: "border-grey-darken-3" }),
                _createVNode(_component_v_sheet, {
                  color: "#0d1117",
                  class: "pa-3 d-flex align-center gap-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_menu, {
                      modelValue: menuOpen.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((menuOpen).value = $event)),
                      "close-on-content-click": false,
                      location: "top start",
                      origin: "overlap",
                      transition: "slide-y-transition"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps(props, {
                          icon: "mdi-help-circle-outline",
                          color: "indigo-lighten-3",
                          variant: "text",
                          density: "comfortable"
                        }), null, 16)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          "min-width": "340",
                          "max-width": "380",
                          class: "pa-4 rounded-lg border border-grey-darken-3 shadow-2xl",
                          color: "#161b22"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_component_v_icon, {
                                icon: "mdi-frequently-asked-questions",
                                class: "me-2"
                              }),
                              _createTextVNode(" Qué puedes preguntar ")
                            ]),
                            _createVNode(_component_v_list, {
                              density: "compact",
                              "bg-color": "transparent",
                              class: "pa-0"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ayudaItems, (item, idx) => {
                                  return _createVNode(_component_v_list_item, {
                                    key: idx,
                                    class: "px-0 py-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { class: "text-body-2 font-weight-medium text-grey-lighten-2" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.titulo), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_list_item_subtitle, { class: "text-caption text-indigo-lighten-4 font-italic" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.ejemplo), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                }), 64))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_divider, { class: "my-3 border-grey-darken-2" }),
                            _hoisted_9,
                            _createVNode(_component_v_row, {
                              dense: "",
                              class: "mb-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "text-caption d-flex align-center text-grey-lighten-2"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_10,
                                    _createTextVNode(),
                                    _hoisted_11
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "text-caption d-flex align-center text-grey-lighten-2"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_12,
                                    _createTextVNode(),
                                    _hoisted_13
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "text-caption d-flex align-center text-grey-lighten-2"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_14,
                                    _createTextVNode(),
                                    _hoisted_15
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "text-caption d-flex align-center text-grey-lighten-2"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_16,
                                    _createTextVNode(),
                                    _hoisted_17
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_divider, { class: "my-3 border-grey-darken-2" }),
                            _createVNode(_component_v_sheet, {
                              color: "#0d1117",
                              class: "pa-2 rounded border border-amber-darken-3"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_18, [
                                  _createVNode(_component_v_icon, {
                                    icon: "mdi-lightbulb-outline",
                                    size: "small",
                                    class: "me-1"
                                  }),
                                  _createTextVNode(" Recordatorio importante: ")
                                ]),
                                _hoisted_19
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: userInput.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((userInput).value = $event)),
                      placeholder: "Escribe un mensaje o usa comando...",
                      variant: "solo",
                      density: "compact",
                      "hide-details": "",
                      flat: "",
                      "bg-color": "#161b22",
                      class: "rounded-lg modern-input border border-grey-darken-3",
                      onKeyup: _withKeys(handleSend, ["enter"]),
                      disabled: isLoading.value
                    }, null, 8, ["modelValue", "onKeyup", "disabled"]),
                    _createElementVNode("div", _hoisted_20, [
                      (userInput.value.trim())
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            icon: "mdi-send",
                            color: "indigo-lighten-1",
                            variant: "text",
                            density: "comfortable",
                            onClick: handleSend,
                            disabled: isLoading.value
                          }, null, 8, ["disabled"]))
                        : (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            icon: isRecording.value ? 'mdi-stop-circle' : 'mdi-microphone',
                            color: isRecording.value ? 'red-lighten-1' : 'indigo-lighten-3',
                            variant: "text",
                            density: "comfortable",
                            class: _normalizeClass({ 'recording-active': isRecording.value }),
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (isRecording.value ? stopAll() : startAll())),
                            disabled: isLoading.value
                          }, null, 8, ["icon", "color", "class", "disabled"]))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})